import {StrictMode, Suspense, lazy} from 'react';
import {createRoot} from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.tsx';
import Analytics from './components/Analytics';
import './index.css';

const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const Protocol = lazy(() => import('./pages/Protocol'));
const AdminApp = lazy(() => import('./admin/AdminApp'));
const Flyer = lazy(() => import('./pages/Flyer'));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Analytics />
      <Suspense fallback={<div>Načítavam...</div>}>
        <Routes>
          <Route path="/ochrana-osobnych-udajov" element={<PrivacyPolicy />} />
          <Route path="/protokol" element={<Protocol />} />
          <Route path="/letak" element={<Flyer />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<App />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </StrictMode>,
);
